import React from 'react';
import { Form, Modal } from 'react-bootstrap';
import moment from 'moment';

// Services
import InstructorService from 'services/InstructorService';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class ReferralCodesModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                isLoading: true,
                instructorID: opts.id
            }, () => {
                this.load();
            });
        });
    }

    async load() {
        this.setState({
            isLoading: true,
            referralCode: null
        });
        const referralCodes = await InstructorService.listReferralCodes(this.state.instructorID);
        this.setState({
            isLoading: false,
            referralCodes
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
    }

    add() {
        this.setState({
            isSuccess: false,
            referralCode: {
                sourceInstructorID: this.state.instructorID
            }
        });
    }

    updateField(fieldName, value) {
        const referralCode = { ...this.state.referralCode };
        referralCode[fieldName] = value;
        this.setState({ referralCode });
    }

    async save() {
        this.setState({ isLoading: true });
        await InstructorService.saveReferralCode(this.state.referralCode);
        this.setState({ isLoading: false, isSuccess: true });
    }

    //------------------------------------------------------------------------------

    render() {
        const {
            isOpen,
            isLoading
        } = this.state;

        if (!isOpen) {
            return null;
        }
        
        return (
            <Modal show className="referral-codes-modal">
                {isLoading ? <Modal.Body><Loader /></Modal.Body> : this.renderInner()}
            </Modal>
        );
    }

    renderInner() {
        const {
            referralCode,
            isSuccess
        } = this.state;

        return (<>
            <Modal.Body>

                {referralCode ?
                    (isSuccess ? this.renderSuccess() : this.renderReferralCode()) :
                    this.renderList()
                }

            </Modal.Body>
            <Modal.Footer>
                {referralCode && !isSuccess ? <>
                    <button type="button" className="btn btn-secondary me-auto" onClick={e => this.setState({ referralCode: null })}>
                        Cancel
                    </button>
                    <button type="button" className="btn btn-primary ms-auto" onClick={e => this.save()}>
                        Send
                    </button>
                </> : <>
                    <button type="button" className="btn btn-secondary me-auto" onClick={e => this.close()}>
                        Close
                    </button>
                    <button type="button" className="btn btn-primary ms-auto" onClick={e => this.add()}>
                        Create a new code
                    </button>
                </>}
            </Modal.Footer>
        </>);
    }

    renderList() {
        const {
            referralCodes
        } = this.state;
        
        if (referralCodes.length == 0) {
            return (
                <div className="empty-text">
                    You have no referral codes. <br />
                    Press the button below to create a new one.
                </div>
            );
        }
        return (
            <table className="table table-bordered mb-0">
                <thead>
                    <tr>
                        <th>Code</th>
                        <th>Date</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {referralCodes.map(rc =>
                        <tr key={rc.id}>
                            <td>{rc.reference}</td>
                            <td>{moment(rc.dateCreated).format('DD/MM/YYYY')}</td>
                            <td>{rc.firstName} {rc.lastName}</td>
                            <td>{rc.email}</td>
                            <td>{this.renderStatus(rc)}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    renderReferralCode() {
        const {
            referralCode
        } = this.state;
        return (<>

            <Form.Group className="mb-3">
                <Form.Label>First Name</Form.Label>
                <input
                    type="text"
                    className="form-control"
                    value={referralCode.firstName}
                    onChange={e => this.updateField('firstName', e.target.value)} 
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Last Name</Form.Label>
                <input
                    type="text"
                    className="form-control"
                    value={referralCode.lastName}
                    onChange={e => this.updateField('lastName', e.target.value)}
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <input
                    type="email"
                    className="form-control"
                    value={referralCode.email}
                    onChange={e => this.updateField('email', e.target.value)}
                />
            </Form.Group>

        </>);
    }

    renderSuccess() {
        const {
            referralCode
        } = this.state;
        return (
            <div className="referral-code-created">
                Thank you, a referral link has been emailed to <b>{referralCode.email}</b>
            </div>
        );
    }

    renderStatus(referralCode) {
        if (referralCode.dateConverted) {
            return 'Used';
        }
        return 'Not used';
    }
}

export default ReferralCodesModal;